export const FETCH_NON_ALLOCATED_EMP_REQUEST = "FETCH_NON_ALLOCATED_EMP_REQUEST";
export const FETCH_NON_ALLOCATED_EMP_SUCCESS = "FETCH_NON_ALLOCATED_EMP_SUCCESS";
export const FETCH_NON_ALLOCATED_EMP_FAILURE = "FETCH_NON_ALLOCATED_EMP_FAILURE";